import { graphql } from 'react-relay';

import IndexingCategory from './containers/IndexingCategory';
import NonIndexablePagesTable from './containers/NonIndexablePagesTable';
import DisallowedPagesTable from './containers/DisallowedPagesTable';
import NofollowedPagesTable from './containers/NofollowedPagesTable';
import DeepPagesTable from './containers/DeepPagesTable';

import { createRenderFunction } from '../../utils/redirects';

export default ({
  path: 'indexing',
  Component: IndexingCategory,
  query: graphql`
    query indexing_IndexingCategory_Query($host: String!) {
      project(host: $host) {
        ...IndexingCategory_project
      }
    }
  `,
  render: createRenderFunction({ redirectTo: '/non-indexable-pages' }),
  prepareVariables: params => ({ ...params, host: params.url }),
  children: [
    {
      Component: NonIndexablePagesTable,
      path: 'non-indexable-pages',
      query: graphql`
        query indexing_IndexingCategory_NonIndexablePagesTable_Query($host: String!) {
          project(host: $host) {
            ...NonIndexablePagesTable_project
          }
        }
      `
    },
    {
      Component: DisallowedPagesTable,
      path: 'disallowed-pages',
      query: graphql`
        query indexing_IndexingCategory_DisallowedPagesTable_Query($host: String!) {
          project(host: $host) {
            ...DisallowedPagesTable_project
          }
        }
      `
    },
    {
      Component: NofollowedPagesTable,
      path: 'no-followed-pages',
      query: graphql`
        query indexing_IndexingCategory_NofollowedPagesTable_Query($host: String!) {
          project(host: $host) {
            ...NofollowedPagesTable_project
          }
        }
      `
    },
    {
      Component: DeepPagesTable,
      path: 'deep-pages',
      query: graphql`
        query indexing_IndexingCategory_DeepPagesTable_Query($host: String!) {
          project(host: $host) {
            ...DeepPagesTable_project
          }
        }
      `
    }
  ]
});
